import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Components
import { HomeListComponent } from './home-list/home-list.component';
import { HomeRoutingModule } from './home-routing.module';
import { CoreModule } from '../core/core.module';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';


@NgModule({
    imports: [
      CommonModule,
      HomeRoutingModule,              
      ChartModule,
      CoreModule,            
      CardModule
    ],
    declarations: [
      HomeListComponent
    ]
  })
  export class HomeModule {
  }
